module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("32qsa"))).then(() => parcelRequire('a7EfY'));